import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// VERSION MARKER - Update this to confirm deployment
const APP_VERSION = "2026-04-10-v4";
console.log(`[Shakatah] App version: ${APP_VERSION}`);

// Production crash triage: surface minified TDZ/circular-init errors with as much context as possible.
// This will help us pinpoint the exact source module once sourcemaps are enabled.
if (typeof window !== "undefined") {
  if (window.location.hostname.toLowerCase() === "www.splitkart.shakatah.com") {
    const primaryUrl = `https://splitkart.shakatah.com${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(primaryUrl);
  }

  window.addEventListener("error", (event) => {
    // eslint-disable-next-line no-console
    console.error("[GlobalError]", {
      message: event.error?.message || event.message,
      filename: (event as any).filename,
      lineno: (event as any).lineno,
      colno: (event as any).colno,
      stack: event.error?.stack,
      href: window.location.href,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = (event as PromiseRejectionEvent).reason;
    // eslint-disable-next-line no-console
    console.error("[UnhandledRejection]", {
      message: reason?.message || String(reason),
      stack: reason?.stack,
      href: window.location.href,
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
